<template>
  <div id="app">
    <m-header v-if="!isAuth"></m-header>
    <router-view />
    <m-footer v-if="!isAuth"></m-footer>
  </div>
</template>

<style lang="scss">
@import '@/assets/scss/base.scss';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>

<script>
import { mapGetters } from 'vuex';
import MHeader from '@/components/MHeader';
import MFooter from '@/components/MFooter';
export default {
  components: {
    MHeader,
    MFooter
  },
  computed: {
    ...mapGetters(['isAuth'])
  }
};
</script>
